import styled, {keyframes} from "styled-components";


const glowRotateAnimation = keyframes`
            0% {
                transform: rotate(0deg);
            }
            20%, 25% {
                transform: rotate(90deg);
            }            
            45%, 50% {
                transform: rotate(180deg);
            }            
            70%, 75% {
                transform: rotate(270deg);
            }
            100% {
                transform: rotate(360deg);
            }
        `;

export const DailyDealChestGlowBox = styled.div`

    background: url(${({theme}) => theme.images.dailyDeal.glow.toString()}) center no-repeat;
    position: relative;
    bottom: 25px;
        
    grid-column: 1;
    grid-row: 1;
    
    height: 106px;
    width: 106px;  
    z-index: -1;
    
    transform: rotate(30deg);
    animation: ${glowRotateAnimation} 4s infinite;
`;
